export default class CommentActionBtn {

  constructor($element) {
    // selectors
    this.SELECTORS = {
      label: '.js-bookmark-comment-label',
    };

    // classes
    this.CLASSES = {
      active: 'active',
      init: 'is-init',
    };

    /**
     * The $BUTTON wrapper
     * @private
     * @type {jQuery|HTMLElement}
     */
    this.$BUTTON = $element;

    /**
     * type of socialize item btn => comment
     */
    this.TYPE = this.$BUTTON.attr('data-socialize-type');

    /**
     * subject of socialize item
     * @example page, news
     */
    this.SOCIAlIZE_OBJECT = this.$BUTTON.attr('data-socialize-object');

    /**
     * page id
     */
    this.PID = this.$BUTTON.attr('data-socialize-pid');

    /**
     * id of action button
     */
    this.UID = this.$BUTTON.attr('data-socialize-uid');

    /**
     * labels
     * @type {{plural: *, singular: *}}
     */
    this.LABEL = {
      plural: this.$BUTTON.attr('data-label-plural'),
      singular: this.$BUTTON.attr('data-label-singular'),
    };

    /**
     * label element
     */
    this.$LABEL_ELEMENT = this.$BUTTON.find(this.SELECTORS.label);

    /**
     * number of comments
     * @type {number}
     */
    this.COUNTER = 0;

    /**
     * is btn active
     * @type {boolean}
     */
    this.IS_ACTIVE = false;

    /**
     * set init state
     * @type {boolean}
     */
    this.IS_INIT = false;

    this.initComponents().then(_ => {
      this.registerHooks();
    });

  }

  /**
   * Initialize components for CommentActionBtn
   * @private
   * @example
   * this.initComponents()
   */
  initComponents() {
    let _this = this;
    return new Promise(resolve => {
      _this.setInitState();
      resolve();
    });

  }

  /**
   * indicate init state of actionbar
   */
  setInitState() {
    let _this = this;
    _this.$BUTTON.addClass(_this.CLASSES.init);
    _this.IS_INIT = true;
  }

  /**
   * Register events for CommentActionBtn
   * @private
   * @example
   * this.registerHooks()
   */
  registerHooks() {
    let _this = this;
    let body = document.querySelector('body');
    body.addEventListener('lin-socialize:comment:update', event => {
      let eventData = _this.getEventDataOfComment(event.detail.data);
      if (eventData) {
        _this.updateCounter(eventData.value);
      }
    });
  }

  /**
   * set counter
   * @param counter
   */
  setCounter(counter) {
    let _this = this;
    _this.COUNTER = counter;
  }

  /**
   * increase counter by one
   */
  increaseCounter() {
    let _this = this;
    _this.COUNTER++;
  }

  /**
   * decrease counter by one
   */
  decreaseCounter() {
    let _this = this;
    _this.COUNTER--;
  }

  /**
   * indicates the counter in markup
   */
  indicateCounterInMarkup() {
    let _this = this;

    if (_this.COUNTER === 0) {
      _this.removeActiveSate();
      return;
    }

    let markup = _this.COUNTER + ' ';

    if (_this.COUNTER > 1) {
      markup += _this.LABEL.plural;
    } else {
      markup += _this.LABEL.singular;
    }

    _this.$LABEL_ELEMENT.html(markup);

  }

  setActive() {
    let _this = this;
    _this.IS_ACTIVE = true;
    _this.$BUTTON.addClass(_this.CLASSES.active);
  }

  removeActiveSate() {
    let _this = this;
    _this.IS_ACTIVE = false;
    _this.$BUTTON.removeClass(_this.CLASSES.active);
  }

  /**
   * update counter value and show change in markup
   * @param counter
   */
  updateCounter(counter) {
    let _this = this;
    _this.setCounter(counter);
    _this.indicateCounterInMarkup();
    if (_this.COUNTER > 0) {
      _this.setActive();
    } else {
      _this.removeActiveSate();
    }
  }

  /**
   * check if the event data belongs to this comment action button
   * @param data
   */
  getEventDataOfComment(data) {
    let _this = this;
    let eventData;
    data.forEach(date => {
      if (date.pid === _this.PID && date.uid === _this.UID) {
        eventData = date;
      }
    });
    return eventData;
  }

}